/**
 * This file is designed only for the events related to the pagination.
 */

import { searchParametersActions } from 'features/searchResultsFacets';
import { createMiddleware } from 'redux-beacon';
import GoogleTagManager from 'middlewares/googleTagManager';
import { addMiddleware } from 'redux-dynamic-middlewares';
import debounceEvent from '@redux-beacon/debounce-event';
import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import { buildNewUrl, getPaging, routingSelectors } from 'features/routing';
import { store } from '@redux/store';

const { urlComponentsSelector } = routingSelectors;

function getURL(pageNumber) {
    const state = store.getState();
    const urlComponents = urlComponentsSelector(state);
    
    urlComponents.urlPaging = getPaging(pageNumber);
    const newURL = buildNewUrl(urlComponents);

    return newURL;
}

const searchEvents = 'Search Events';
 
const pageNumberChanged = (action) => new GoogleAnalyticsEvent(searchEvents, action.payload, getURL(action.payload));

const pageSizeChanged = (action) => new GoogleAnalyticsEvent(searchEvents, 'Sort Option Selected', `${action.payload} per page`);

const pagingControlsClickPrevious = (action) => new GoogleAnalyticsEvent(searchEvents, 'Previous', 
    getURL(action.payload));

const pagingControlsClickNext = (action) => new GoogleAnalyticsEvent(searchEvents, 'Next', getURL(action.payload));

const eventsMapper = (action) => {
    switch (action.type) {
        case searchParametersActions.fetchPagingControlsPrev.type:
            return debounceEvent(1000, pagingControlsClickPrevious);
        case searchParametersActions.fetchPagingControlsNext.type:
            return debounceEvent(1000, pagingControlsClickNext);
        case searchParametersActions.fetchPageSize.type:
            return debounceEvent(1000, pageSizeChanged);
        case searchParametersActions.fetchPageNumber.type:
            return debounceEvent(1000, pageNumberChanged);
        default:
            return [];
    }
};

const googleTagManager = new GoogleTagManager();
const searchResultsGoogleTagManagerMiddleware = createMiddleware(eventsMapper, googleTagManager.getTarget());
addMiddleware(searchResultsGoogleTagManagerMiddleware);